import { CommonError } from '../../../types';
import { FETCH_NEWS_FAILURE, FETCH_NEWS_REQUEST, FETCH_NEWS_SUCCESS } from './constants';
import { NewsData, payloadData } from './types';

export interface FetchNewsRequestAction {
    type: typeof FETCH_NEWS_REQUEST;
    payload: payloadData;
}

export interface FetchNewsSuccessAction {
    type: typeof FETCH_NEWS_SUCCESS;
    payload: NewsData[];
}

export interface FetchNewsFailureAction {
    type: typeof FETCH_NEWS_FAILURE;
    payload: CommonError;
}

export type NewsActions = FetchNewsRequestAction | FetchNewsSuccessAction | FetchNewsFailureAction;

export const fetchNewsRequest = (payload: payloadData): FetchNewsRequestAction => ({
    type: FETCH_NEWS_REQUEST,
    payload,
});

export const fetchNewsSuccess = (newsDatas: NewsData[]): FetchNewsSuccessAction => ({
    type: FETCH_NEWS_SUCCESS,
    payload: newsDatas,
});

export const fetchNewsFailure = (error: CommonError): FetchNewsFailureAction => ({
    type: FETCH_NEWS_FAILURE,
    payload: error,
});
